import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.testimonials-block__slider')
  if (!wrapper.length) {
    return
  }

  new Swiper(wrapper[0], {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      prevEl: $block.find('.testimonials-block__nav--prev')[0],
      nextEl: $block.find('.testimonials-block__nav--next')[0],
    },
    pagination: {
      el: $block.find('.testimonials-block__pagination')[0],
      clickable: true,
    },
    autoHeight: true,
  })
}

$('.testimonials-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-testimonials',
    initializeBlock
  )
}
